import { render, staticRenderFns } from "./AuctionsCount.vue?vue&type=template&id=dca0d76e&"
import script from "./AuctionsCount.vue?vue&type=script&lang=js&"
export * from "./AuctionsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports